import { render } from "./SlideDataFormImages.vue?vue&type=template&id=22f3c2a8"
import script from "./SlideDataFormImages.vue?vue&type=script&lang=js"
export * from "./SlideDataFormImages.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__